import { render, staticRenderFns } from "./DashboardAssessmentCard.vue?vue&type=template&id=32593ec9&scoped=true"
import script from "./DashboardAssessmentCard.vue?vue&type=script&lang=ts"
export * from "./DashboardAssessmentCard.vue?vue&type=script&lang=ts"
import style0 from "./DashboardAssessmentCard.vue?vue&type=style&index=0&id=32593ec9&prod&scoped=true&lang=scss"
import style1 from "./DashboardAssessmentCard.vue?vue&type=style&index=1&id=32593ec9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32593ec9",
  null
  
)

export default component.exports